'use client';

import type { ComponentType } from 'react';
import type { SectionBlock, PageBlock } from '@impact/types';
import type { EditableWrapper } from '../types';
import { BlockRenderer } from '../BlockRenderer';

interface Props {
  block: SectionBlock;
  editing?: boolean;
  Wrapper?: EditableWrapper;
}

export function SectionVideoBackground({ block, editing, Wrapper }: Props) {
  const { bgVideoUrl, bgPosterUrl } = block.data;

  return (
    <section className="relative overflow-hidden py-24 text-white">
      {bgVideoUrl ? (
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <video
          className="absolute inset-0 h-full w-full object-cover"
          src={bgVideoUrl}
          poster={bgPosterUrl}
          autoPlay={!editing}
          muted
          loop
          playsInline
        />
      ) : (
        <div className="absolute inset-0 bg-gradient-to-br from-zinc-900 via-zinc-800 to-zinc-700" />
      )}
      <div className="absolute inset-0 bg-black/40" />
      <div className="relative z-10 mx-auto max-w-5xl px-4">
        {block.data.blocks.map((child: PageBlock) => (
          <BlockRenderer key={child.id} block={child} editing={editing} Wrapper={Wrapper} />
        ))}
      </div>
    </section>
  );
}
